import React from 'react';
import { Button } from '@mui/material';
import { Link } from 'react-router-dom';
import AlternateEmailIcon from '@mui/icons-material/AlternateEmail';

const SignUpOptions = ({ loading, onSignUpWithEmail }) => (
  <div style={{ display: 'flex', flexDirection: 'column', gap: 12 }}>
    <Button
      fullWidth
      variant="outlined"
      color="inherit"
      startIcon={<AlternateEmailIcon style={{ fontSize: 18 }} />}
      onClick={onSignUpWithEmail}
      style={{ borderRadius: 8, height: 42, textTransform: 'none', fontWeight: 500 }}
    >
      Sign Up with Email
    </Button>
    <div className="auth-bottom-link" style={{ marginTop: 8 }}>
      Already have an account? <Link to="/">Sign in</Link>
    </div>
  </div>
);

export default SignUpOptions;
